const cfg = {
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  VUE_APP_BASE_API: process.env.VUE_APP_BASE_API
}
export default cfg
